// extracted by mini-css-extract-plugin
export default {"wrap":"J_zdFv","texts":"TCqIlZ","header":"MmB6aR","hidden":"rDWVAC","description":"dabCte"};